<script lang="ts">
    import { getImageSizeUrl } from "@/utils/getImageSizeUrl";
    import ReviewsRatingStars from "@apps/reviews/components_v2/ReviewsRatingStars/ReviewsRatingStars.svelte";
    import ReviewEntity from "@apps/reviews/entities/ReviewEntity";
    import Thumbnail from "@components_v2/Thumbnail/Thumbnail.svelte";
    import Text from "@components_v2/Typography/Text.svelte";
    import { I18nModule } from "@modules/i18n/I18nModule";
    import { createEventDispatcher } from "svelte";
    import { container } from "tsyringe";

    import BaseButton from "@components/Buttons/BaseButton.svelte";

    export let review: ReviewEntity;

    const dispatch = createEventDispatcher();

    const i18nModule = container.resolve(I18nModule);
    const t_anonym$ = i18nModule.exports.i18n.selectT(
        "reviews.ProductReviewsMiniSliderWidget",
        "anonym"
    );

    const handleOpenReview = (event: Event) => {
        event.preventDefault();
        event.stopPropagation();
        dispatch("openReview", review.uid);
    };

    $: customerName = review.customer?.name ?? $t_anonym$;
</script>

<div class="gw-rv-product-mini-slider-item">
    <BaseButton
        ariaLabel={"Open review " + review.title}
        on:click={handleOpenReview}
    >
        <div class="gw-rv-product-mini-slider-item__card">
            {#if review.images[0]}
                <div class="gw-rv-product-mini-slider-item__image-wrapper">
                    <Thumbnail
                        src={getImageSizeUrl(review.images[0].sizes, "xs") ||
                            ""}
                        size="medium"
                        alt={review.title || "Review image"}
                    />
                </div>
            {/if}

            <div class="gw-rv-product-mini-slider-item__content">
                <div class="gw-rv-product-mini-slider-item__header">
                    <Text
                        variant="heading-md"
                        class="gw-rv-product-mini-slider-item__review-author"
                    >
                        {customerName}
                    </Text>

                    <ReviewsRatingStars rating={review.rating} />
                </div>
                <Text
                    variant="body-lg"
                    class="gw-rv-product-mini-slider-item__text"
                >
                    {review.body}
                </Text>
            </div>
        </div>
    </BaseButton>
</div>

<style lang="postcss">
    .gw-rv-product-mini-slider-item {
        --slide-gap: 32px;
        display: flex;
        padding: var(--gw-space-200) var(--slide-gap);
        flex: 0 0 calc(100% - (var(--slide-gap) * 2));

        &__card {
            display: flex;
            flex-wrap: nowrap;
            gap: 0.5em;
        }

        &__image-wrapper {
            width: 64px;
            height: 64px;
        }

        &__content {
            display: flex;
            align-items: start;
            flex-direction: column;
            overflow: hidden;
            row-gap: 4px;
        }

        &__header {
            width: 100%;
            display: flex;
            align-items: center;
            justify-content: space-between;
            gap: 0.625em;
            text-align: left;
            overflow: hidden;
        }

        :global(&__review-author) {
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-line-clamp: 1;
            -webkit-box-orient: vertical;
        }

        :global(&__text) {
            text-align: left;
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-line-clamp: 2;
            -webkit-box-orient: vertical;
        }
    }
</style>
